module.exports = {
  BlossomComponents: {
    minChunks: 2,
    minSize: 6000,
    name(module) {
      const generateName = (folder) => {
        const s = module.userRequest.split("/");
        const index = s.indexOf(folder);

        return s.slice(index, index + 2).join("~");
      };

      if (module.userRequest.includes("components/shared")) {
        return generateName("shared");
      }

      if (module.userRequest.includes("components/flexComponents")) {
        return generateName("flexComponents");
      }

      return generateName("utility");
    },
    priority: 100,
    reuseExistingChunk: true,
    test: (module) => /[\/]components[\/](?=flexComponents|shared|utility)/.test(module.resource),
  },
  TravelersField: {
    name: "shared~TravelersField",
    priority: 100,
    reuseExistingChunk: true,
    test: (module) => /[\/]components[\/]shared[\/]TravelersField[\/]/.test(module.resource),
  },
  UitkTypeahead: {
    enforce: true,
    name: "uitk-typeahead",
    priority: 100,
    test: (module) => /([\/]node_modules[\/]uitk-react-typeahead)/.test(module.resource),
  },
};
